export default {
  empty: 'Pre túto zákazku nebola zaznamenaná žiadna spotreba.',
};
